<template>
  <div class="xcard">
    <v-toolbar-title class="mb-5 py-2" style="border-bottom: 1px solid #d4dbe0">
      <div class="d-flex flex-wrap justify-space-between align-center">
        <span>REPORTE PRESUPUESTARIO DE INGRESOS</span>

        <div class="d-flex justify-end align-center">
          <div style="max-width: 200px">
            <v-select
              :items="gestiones"
              label="Gestion"
              item-text="numero"
              item-value="id"
              v-model="gestionId"
              @input="setGestionId"
              placeholder=" "
              outlined
              dense
              hide-details />
          </div>

          <v-btn color="ml-4" small @click="recargarTodos" title="Recargar Todos">
            <v-icon>mdi-refresh</v-icon>
            Recargar Todos
          </v-btn>

          <v-switch
            class="ml-4"
            :value="mostradoDetalleTodos"
            label="Mostrar Detalle de Todos"
            hide-details
            @change="toggleDetalleTodos"></v-switch>
        </div>
      </div>
    </v-toolbar-title>

    <template v-if="gestion?.numero == '2023'">
      <ReporteIngresos :ingresos="ingresosEstimadosGestion" @recargar="listarIngresosEstimadosGestion">
        <h3 class="h3">Ingresos Estimados</h3>

        <v-chip class="ma-2" outlined small color="orange"> Pendiente </v-chip>
      </ReporteIngresos>

      <ReporteIngresos
        :ingresos="ingresosEstimadosAceptadosGestion"
        @recargar="listar('ingresosEstimadosAceptadosGestion')">
        <h3 class="h3">Ingresos Estimados</h3>

        <v-chip class="ma-2" outlined small color="success"> Aceptado </v-chip>
      </ReporteIngresos>
    </template>

    <ReporteIngresos :ingresos="ingresosProyectadosGestion" @recargar="listar('ingresosProyectadosGestion')">
      <h3 class="h3">Ingresos Proyectados</h3>
    </ReporteIngresos>

    <ReporteIngresos :ingresos="ingresosOtrosGestion" @recargar="listar('ingresosOtrosGestion')">
      <h3 class="h3">Ingresos</h3>
    </ReporteIngresos>

    <hr class="my-16" />

    <ReporteIngresosTotales
      :ingresosEstimadosGestionTotales="ingresosEstimadosGestion.totales"
      :ingresosEstimadosAceptadosGestionTotales="ingresosEstimadosAceptadosGestion.totales"
      :ingresosProyectadosGestionTotales="ingresosProyectadosGestion.totales"
      :ingresosOtrosGestionTotales="ingresosOtrosGestion.totales"
      :gestion="gestion" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import ReporteIngresos from '../components/PresupuestoReporteIngresos/ReporteIngresos.vue';
import ReporteIngresosTotales from '../components/PresupuestoReporteIngresos/ReporteIngresosTotales.vue';
import IngresoServices from '../services/ingresos';
import PresupuestosServices from '../services/index';
import { ESTADOS_DETALLE_TRANSACCION, formatearErrores, TIPOS_PRESUPUESTOS } from '../utils';
import GetGestionesMixin from '../mixins/get-gestiones-mixin';

export default {
  name: 'PresupuestoReporteIngresos',
  mixins: [GetGestionesMixin],
  components: {
    ReporteIngresos,
    ReporteIngresosTotales,
  },
  data() {
    return {
      claves: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre',
        'total',
      ],
      ingresosEstimadosGestion: {
        data: [],
        cargando: false,
        mostradoDetalle: false,
        totales: {
          enero: 0,
          febrero: 0,
          marzo: 0,
          abril: 0,
          mayo: 0,
          junio: 0,
          julio: 0,
          agosto: 0,
          septiembre: 0,
          octubre: 0,
          noviembre: 0,
          diciembre: 0,
          total: 0,
        },
      },
      ingresosProyectadosGestion: {
        data: [],
        cargando: false,
        mostradoDetalle: false,
        totales: {
          enero: 0,
          febrero: 0,
          marzo: 0,
          abril: 0,
          mayo: 0,
          junio: 0,
          julio: 0,
          agosto: 0,
          septiembre: 0,
          octubre: 0,
          noviembre: 0,
          diciembre: 0,
          total: 0,
        },
      },
      ingresosOtrosGestion: {
        data: [],
        cargando: false,
        mostradoDetalle: false,
        totales: {
          enero: 0,
          febrero: 0,
          marzo: 0,
          abril: 0,
          mayo: 0,
          junio: 0,
          julio: 0,
          agosto: 0,
          septiembre: 0,
          octubre: 0,
          noviembre: 0,
          diciembre: 0,
          total: 0,
        },
      },
      ingresosEstimadosAceptadosGestion: {
        data: [],
        cargando: false,
        mostradoDetalle: false,
        totales: {
          enero: 0,
          febrero: 0,
          marzo: 0,
          abril: 0,
          mayo: 0,
          junio: 0,
          julio: 0,
          agosto: 0,
          septiembre: 0,
          octubre: 0,
          noviembre: 0,
          diciembre: 0,
          total: 0,
        },
      },
    };
  },
  mounted() {
    this.obtenerGestiones();
  },
  computed: {
    mostradoDetalleTodos() {
      return (
        this.ingresosEstimadosGestion.mostradoDetalle &&
        this.ingresosProyectadosGestion.mostradoDetalle &&
        this.ingresosOtrosGestion.mostradoDetalle &&
        this.ingresosEstimadosAceptadosGestion.mostradoDetalle
      );
    },
  },
  watch: {
    '$store.state.CARGO.sede.id': function (val) {
      if (val && this.gestionId) {
        this.recargarTodos();
      }
    },
    'gestion.numero': {
      handler: function (val) {
        if (val && this.$store.state.CARGO.sede.id) {
          this.recargarTodos();
        }
      },
      immediate: true,
    },
    'ingresosEstimadosGestion.data': function (val) {
      if (val.length == 0) {
        this.ingresosEstimadosGestion.mostradoDetalle = false;
      }
    },
    'ingresosProyectadosGestion.data': function (val) {
      if (val.length == 0) {
        this.ingresosProyectadosGestion.mostradoDetalle = false;
      }
    },
    'ingresosOtrosGestion.data': function (val) {
      if (val.length == 0) {
        this.ingresosOtrosGestion.mostradoDetalle = false;
      }
    },
    'ingresosEstimadosAceptadosGestion.data': function (val) {
      if (val.length == 0) {
        this.ingresosEstimadosAceptadosGestion.mostradoDetalle = false;
      }
    },
  },
  methods: {
    recargarTodos() {
      if (this.gestion?.numero == '2023') {
        this.listarIngresosEstimadosGestion();
        this.listar('ingresosEstimadosAceptadosGestion');
      }
      this.listar('ingresosProyectadosGestion');
      this.listar('ingresosOtrosGestion');
    },
    async listarIngresosEstimadosGestion() {
      this.ingresosEstimadosGestion.cargando = true;
      try {
        const params = {
          sede_id: this.$store.state.CARGO.sede.id,
          gestion_id: this.gestionId,
          estado: ESTADOS_DETALLE_TRANSACCION.PENDIENTE,
        };
        const response = await IngresoServices.findGestionEstado({ params });
        const data = [];

        this.claves.map((clave) => {
          this.ingresosEstimadosGestion.totales[clave] = 0;
        });

        response.data.datos.forEach((estimacion) => {
          if (estimacion.concepto !== 'TOTALES') {
            const indice = data.findIndex((datum) => datum.estimacion_id === estimacion.estimacion_id);

            this.claves.map((clave) => {
              this.ingresosEstimadosGestion.totales[clave] += parseFloat(estimacion[clave]);
            });

            if (indice == -1) {
              data.push({
                estimacion_id: estimacion.estimacion_id,
                nombre: estimacion.nombre_programa,
                enero: parseFloat(estimacion.enero),
                febrero: parseFloat(estimacion.febrero),
                marzo: parseFloat(estimacion.marzo),
                abril: parseFloat(estimacion.abril),
                mayo: parseFloat(estimacion.mayo),
                junio: parseFloat(estimacion.junio),
                julio: parseFloat(estimacion.julio),
                agosto: parseFloat(estimacion.agosto),
                septiembre: parseFloat(estimacion.septiembre),
                octubre: parseFloat(estimacion.octubre),
                noviembre: parseFloat(estimacion.noviembre),
                diciembre: parseFloat(estimacion.diciembre),
                total: parseFloat(estimacion.total),
              });
            } else {
              data[indice].enero += parseFloat(estimacion.enero);
              data[indice].febrero += parseFloat(estimacion.febrero);
              data[indice].marzo += parseFloat(estimacion.marzo);
              data[indice].abril += parseFloat(estimacion.abril);
              data[indice].mayo += parseFloat(estimacion.mayo);
              data[indice].junio += parseFloat(estimacion.junio);
              data[indice].julio += parseFloat(estimacion.julio);
              data[indice].agosto += parseFloat(estimacion.agosto);
              data[indice].septiembre += parseFloat(estimacion.septiembre);
              data[indice].octubre += parseFloat(estimacion.octubre);
              data[indice].noviembre += parseFloat(estimacion.noviembre);
              data[indice].diciembre += parseFloat(estimacion.diciembre);
              data[indice].total += parseFloat(estimacion.total);
            }
          }
        });

        this.ingresosEstimadosGestion.data = data;
      } catch (err) {
        window.console.log(err);
      } finally {
        this.ingresosEstimadosGestion.cargando = false;
      }
    },
    async listar(key) {
      if (!['ingresosProyectadosGestion', 'ingresosOtrosGestion', 'ingresosEstimadosAceptadosGestion'].includes(key)) {
        return;
      }

      this[key].cargando = true;

      try {
        const params = {
          sede_id: this.$store.state.CARGO.sede.id,
          gestion_id: this.gestionId,
          tipo:
            key == 'ingresosProyectadosGestion'
              ? TIPOS_PRESUPUESTOS.INGRESO_PROYECTADO
              : key == 'ingresosOtrosGestion'
              ? TIPOS_PRESUPUESTOS.INGRESO
              : TIPOS_PRESUPUESTOS.INGRESO_ESTIMADO,
        };
        const response = await PresupuestosServices.findOneWhereEstimacionSedeIdAndGestionTipo({ params });

        this[key].data = response.data.datos;
        this.claves.map((clave) => {
          this[key].totales[clave] = 0;
        });
        this[key].data.forEach((estimacion) => {
          this.claves.map((clave) => {
            this[key].totales[clave] += parseFloat(estimacion[clave]);
          });
        });
      } catch (error) {
        const { mensaje, errores } = error.response.data;
        const erroresFormateados = formatearErrores(errores);

        this.errores = errores;
        this.$notify({
          group: 'notifications',
          title: mensaje,
          text: erroresFormateados,
          type: 'error',
        });

        window.console.log({ error });
      } finally {
        this[key].cargando = false;
      }
    },
    toggleDetalleTodos() {
      if (this.mostradoDetalleTodos) {
        this.ingresosEstimadosGestion.mostradoDetalle = false;
        this.ingresosProyectadosGestion.mostradoDetalle = false;
        this.ingresosOtrosGestion.mostradoDetalle = false;
        this.ingresosEstimadosAceptadosGestion.mostradoDetalle = false;
      } else {
        this.ingresosEstimadosGestion.mostradoDetalle = true;
        this.ingresosProyectadosGestion.mostradoDetalle = true;
        this.ingresosOtrosGestion.mostradoDetalle = true;
        this.ingresosEstimadosAceptadosGestion.mostradoDetalle = true;
      }
    },
  },
};
</script>
